import { VITE_USE_MOCK, VITE_MOCK_API, VITE_REPORT_MANAGER_API } from 'Constants/appEnvConstants'

export default function getReportsBaseUrl() {
    return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_REPORT_MANAGER_API; // eslint-disable-line no-undef
  }
